export const MESSAGE_EVENT_CREATE_SUCCESS = 'An event has been created successfully';
export const MESSAGE_EVENT_CREATE_FAILED = 'There was a problem creating the event';

export const MESSAGE_VENUE_CREATE_SUCCESS = 'An venue has been created successfully';
export const MESSAGE_VENUE_CREATE_FAILED = 'There was a problem creating the venue';
